<template>
  <div
    class="has-background-white is-border"
    id="documents">
    <!-- <document-list
      v-if="contact"
      :source-documents="contact.documents"
      :document-name="`des documents du contact ${contact.last_name} ${contact.first_name}`"></document-list> -->
    <div class="has-background-light is-padding">
      <div class="title is-5">
        <b class="is-uppercase">Documents</b>
      </div>
      <tabs
        :links="documentsTabs"
        :level="1"
        :current-tab="documentsTab"
        classes="has-background-light"
        mode="emitter"
        @changeView="documentsTab = $event"
        :is-fullwidth="true"></tabs>
      <div class="is-padding-top">
        <upload-file
          :multiple="true"
          :custom-id="'documents'"
          :placeholder="'Sélectionner document(s)'"
          :source-documents="documentsToDisplay"
          :has-destination="true"
          :destinations-list="contactDocumentsDestinations"
          :hide-upload="documentsTab !== 'DOCUMENTS'"
          @upload="uploadDocument({ files: $event })"
          @deleteDocument="deleteDocument({ document: $event })"></upload-file>
      </div>
    </div>
    <submit-sticky-buttons
      v-if="!fromQuickview"
      @submit="submit"
      :loading="submitLoading"
      button-id="contactForm"></submit-sticky-buttons>
  </div>
</template>

<script>
import ContactMixin from '../ContactMixin'
import { isObject } from 'lodash'

export default {
  name: 'ContactDocument',
  components: {
    // DocumentList: () => import('@/components/utils/DocumentList')
  },
  mixins: [ContactMixin],
  data () {
    return {
      documentsTab: 'DOCUMENTS'

    }
  },
  computed: {
    documentsTabs () {
      const docs = [
        {
          label: `TOUS LES DOCUMENTS (${this.allDocumentList.length || 0})`,
          link: 'DOCUMENTS',
          class: 'is-size-6'
        },
        {
          label: `DOSSIER DE RÉSERVATION (Annexé au contrat) (${this.reservationDocumentList.length || 0})`,
          link: 'RESERVATION',
          class: 'is-size-6'
        }
      ]
      return docs
    },
    allDocumentList () {
      if (this.contact.documents) {
        return this.contact.documents
      } else {
        return []
      }
    },
    reservationDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('reservation')
      })
    },
    buyerSpaceDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('buyer_space')
      })
    },
    contactDocumentsDestinations () {
      const destinations = {
        reservation: { label: 'Dossier de réservation', key: 'reservation', enabled: true },
        buyer_space: { label: 'Espace acquéreur', key: 'buyer_space', enabled: false }
      }

      return Object.values(destinations)
    },
    documentsToDisplay () {
      if (this.documentsTab === 'RESERVATION') return this.reservationDocumentList
      else if (this.documentsTab === 'ESPACE_ACQUEREUR') return this.buyerSpaceDocumentList
      else return this.allDocumentList
    }
  },
  methods: {
    async submit () {
      this.submitLoading = true
      const cleanContact = this.$cleanPayload(this.contact)
      if (Array.isArray(cleanContact.programs) && isObject(cleanContact.programs[0])) {
        cleanContact.programs = [cleanContact.programs[0].pk]
      }
      if (cleanContact.original_program && cleanContact.original_program.pk) {
        cleanContact.original_program = cleanContact.original_program.pk
      }
      try {
        await this.$api.put(this.$resources.CONTACT, this.contact.pk, cleanContact)
        this.submitLoading = false
        this.$toasted.global.success('Contact modifié')
      } catch (e) {
        console.log(e)
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    }
  }
}
</script>
